// extracted by mini-css-extract-plugin
export default {"container":"Banner_container__AqI6m","Main":"Banner_Main__Xf8bC"};